import useCookie from './useCookie';

const useToken = () => useCookie<string>('token');

export default useToken;
